import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import Modal from '../Modal/Modal';

export default class InfoMessage extends Component {
    constructor(props) {
        super(props);
        this.modalRef = React.createRef();
    }

    render() {
        const { modalProps, actionLabel, children, testId, ...rest } = this.props;
        return (
            <>
                <Button
                    label={actionLabel}
                    icon="info"
                    type="link-flex-info"
                    {...rest}
                    onClick={() => this.modalRef.current.open()}
                    testId={`${testId}-button`}
                />
                <Modal ref={this.modalRef} footer={false} testId={`${testId}-modal`} {...modalProps}>
                    {children}
                </Modal>
            </>
        );
    }
}
InfoMessage.defaultProps = {
    actionLabel: '',
    modalProps: {},
    testId: 'info-message',
};
InfoMessage.propTypes = {
    testId: PropTypes.string,
    children: PropTypes.node.isRequired,
    actionLabel: PropTypes.string,
    modalProps: PropTypes.object,
};
